import React from 'react'
import HeaderContact from '../Components/contact/HeaderContact'
import MainContact from '../Components/contact/MainContact'
import TopContactApout from '../Components/contact/TopContactApout'

const Contact = () => {
  return (
    <>
        <HeaderContact/>
        <TopContactApout/>
        <MainContact/>
    </>
  )
}

export default Contact